import config from 'config';

import { isWindowAvailable } from './is-window-available';

export const COOKIE_PATH = '/';
export const COOKIE_DOMAIN = isWindowAvailable ? window.location.hostname : config.cookieDomain;

export const COOKIE_CONSENT = 'wtr_cookie_consent';
export const COOKIE_ADVERTISING = 'wtr_cookies_advertising';
export const COOKIE_ANALYTICS = 'wtr_cookies_analytics';
export const COOKIE_FUNCTIONAL = 'wtr_cookies_functional';

export const COOKIE_MONETATE_ID = 'mt.v';

export const SET_COOKIE_HEADER = 'set-cookie';

export const SESSION_TOKEN = 'JSESSIONID_TC';

export const HAS_TOKEN_SESSION_HEADER = 'X-Has-Token-Session';
